import { ClockIcon, DocumentTextIcon, NewspaperIcon, TableIcon, TagIcon, UserGroupIcon } from "@heroicons/react/outline";
import { PencilIcon } from "@heroicons/react/solid";
import { Breadcrumbs } from "components/breadcrumbs";
import Button from "components/button";
import { Permissions } from "./components";
import { Link } from "react-router-dom";
import { useOne, useParse } from "@refinedev/core";
import { IOrgRoleDetail } from "interfaces";
import { FullScreenLoading } from "components/fullScreenLoading";
import { DescriptionItem } from "components/descriptionItem";
import { SwitchButton } from "components/switchButton";
import { useState } from "react";
import { HistoryLodModal } from "components/historyLogModal";
import { isHaveActionPermission } from "utills/helpers";

export const OrgRoleDetail: React.FC = () => {
  const [openLogModal, setOpenLogModal] = useState(false);
  const parse = useParse();
  const { params } = parse();

  const {
    data,
    isFetching,
    isPreviousData,
    isLoading,
  } = useOne<IOrgRoleDetail>({
    resource: "organization/role",
    id: params?.id,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });

  const orgRoleDetailData = data?.data ?? null;

  if (isLoading) {
    return <FullScreenLoading />
  }

  return (
    <div className="wrapper">
      <Breadcrumbs
        customPageLabel="Org's Role Detail"
        additionalLabel={
          <div className="flex gap-x-2.5">
            <Button
              className="bg-white border-brand-500 border-[1px] border-solid text-brand-500 hover:bg-white active:bg-slate-200"
              onClick={() => setOpenLogModal(true)}
            >
              <span className="sr-only">History Log</span>
              <ClockIcon className="w-4 h-4 text-brand-500" />{" "}
              <span className="hidden sm:block sm:ml-2">Log</span>
            </Button>
            {isHaveActionPermission(
              "role_management",
              "organization",
              "edit"
            ) ? (
              <Link
                to={`/organization/roles/${orgRoleDetailData?.role.id}/edit`}
              >
                <Button>
                  <span className="sr-only">Edit Role</span>
                  <PencilIcon className="w-4 h-4 text-white" />{" "}
                  <span className="hidden sm:block sm:ml-2">Edit Role</span>
                </Button>
              </Link>
            ) : (
              <></>
            )}
          </div>
        }
      />
      <div className="box-container p-0">
        <div className="border-t border-gray-100">
          <div className="divide-y divide-gray-100">
            <DescriptionItem 
              icon={TagIcon}
              label="Status"
              content={(
                <p className="flex gap-x-2 text-sm leading-6 sm:col-span-4">
                  <SwitchButton disabled checked={orgRoleDetailData?.role.is_active ?? false} onChange={() => {}} />
                  {orgRoleDetailData?.role.is_active ? "Active" : "Inactive"}
                </p>
              )}
            />
            <DescriptionItem 
              icon={UserGroupIcon}
              label="Org name"
              content={(
                <p className="text-sm leading-6 sm:col-span-4">{orgRoleDetailData?.role.organization_name}</p>
              )}
            />
            <DescriptionItem 
              icon={DocumentTextIcon}
              label="Role name"
              content={(
                <p className="text-sm leading-6 sm:col-span-4">{orgRoleDetailData?.role.name}</p>
              )}
            />
            <DescriptionItem 
              icon={NewspaperIcon}
              label="Role description"
              content={(
                <p className="text-sm leading-6 sm:col-span-4">{orgRoleDetailData?.role.description}</p>
              )}
            />
            <DescriptionItem 
              icon={TableIcon}
              label="Access Permisions"
              content={(
                <div className="sm:col-span-4 sm:mt-4 md:mt-0">
                  <Permissions
                    disabled
                    organizationId={orgRoleDetailData?.role.organization_id}
                    data={orgRoleDetailData?.role_permission ?? []} />
                </div>
              )}
            />
          </div>
        </div>
      </div>
      <HistoryLodModal
        resource={`organization/role/${params?.id}/history`}
        open={openLogModal}
        onClose={() => setOpenLogModal(false)}
        key="organization-role"
        id="organization-role"
      />
      
      {(isFetching && isPreviousData) ? <FullScreenLoading /> : <></>}
    </div>
  );
}